export const THIRTY_DAYS = 2592000;
export const THREE_WEEKS = 1814400;
export const SEVEN_DAYS = 604800;
export const ONE_DAY = 86400;
export const SIX_HOURS = 21600;
export const FIVE_MINUTES = 300;
export const THIRTY_SECONDS = 30;
export const TEN_SECONDS = 10;
export const FIVE_SECONDS = 5;
export const ONE_SECOND = 1;
//# sourceMappingURL=time.js.map